import { createSelector } from 'reselect';

const tagsSelector = state => state.killshot.tags;
const assigneeSelector = createSelector(tagsSelector, tags => {
  return tags.map(tag => tag.tags.pricer).filter(el => el !== null);
});

export default assigneeSelector;
